import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const VisualLanguagePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "VisualLanguagePopup" */ './View'),
  'popup'
);
